<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" (click)="activeModal.close()">X</button>
    </div>
    <div class="modal-body">
        <ngx-doc-viewer [url]="url" viewer="pdf" style="width:100%;height:85vh;"></ngx-doc-viewer>
        <div *ngIf="loading" class="text-center">Loading...</div>
    </div>
</div>